/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import IntlMsg from 'lorautils/intl/IntlMsg';
import parserActions from 'loraactions/parser';
import { callAPI } from 'lorautils/api';
import styles from './styles.scss';

const propTypes = {
  show: React.PropTypes.bool.isRequired,
  onHide: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  parser: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  getParsers: React.PropTypes.func.isRequired,
};

class ParserDelModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      parser: props.parser,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers.delete');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { show, parser } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (parser !== this.props.parser) {
      this.setState({ parser });
    }
  }

  handleSubmit() {
    const { parser } = this.state;
    callAPI({
      endpoint: `/lora/parsers/${parser.id}`,
      method: 'DELETE',
    }).then(() => {
      this.setState({ deleteStatus: 'success' });
    }).catch(() => {
      this.setState({ deleteStatus: 'failure' });
    });
  }

  handleSuccess() {
    const { appId, getParsers, onHide } = this.props;
    getParsers({ appid: appId });
    onHide();
  }

  render() {
    const { onHide } = this.props;
    const { show, parser, deleteStatus = '' } = this.state;
    return (
      <Modal bsClass="aisz-modal-danger" show={show} onHide={onHide}>
        <Modal.Header closeButton>
          {this.intlMsg.msg('modalheader')}
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            {this.intlMsg.msg('modalbody')}
            <span className={styles.name}>
              {parser.name}
            </span>
            ?
            <div className={styles.buttons}>
              <Button bsStyle="aisz-warning" onClick={onHide}>
                <span className="halflings halflings-repeat" />{' '}
                {this.intlMsg.msg('cancel')}
              </Button>
              <RichButton
                status={deleteStatus}
                states={[{
                  status: 'default',
                  style: 'danger',
                  label: (
                    <span>
                      <span className="halflings halflings-remove" />{' '}
                      {this.intlMsg.msg('submit')}
                    </span>
                  ),
                  onClick: this.handleSubmit,
                }, {
                  status: 'pending',
                  style: 'info',
                  label: (
                    <span>
                      <i className="fa fa-spinner fa-spin" />{' '}
                      {this.intlMsg.msg('submitting')}
                    </span>
                  ),
                }, {
                  status: 'success',
                  style: 'success',
                  label: (
                    <span>
                      <span className="halflings halflings-tick" />
                      {' '}{this.intlMsg.msg('submitsucc')}
                    </span>
                  ),
                  timer: this.handleSuccess,
                  delay: 500,
                }]}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  getParsers: parserActions.getParsers,
};

ParserDelModal.propTypes = propTypes;

export default connect(null, mapDispatchToProps)(injectIntl(ParserDelModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ParserDelModal/index.jsx